import Icon from 'components/Utils/NewIcon';
import React from 'react';

const CheckIcon = ({ task, onClick, width = '30px', height = '30px' }) => (
  <div className="check">
    <Icon
      src="circle-check"
      width={width}
      height={height}
      fontAwesomeStyle="fad"
      className={'blue ' + (task.status ? 'completed' : 'not-completed')}
      showTooltip={true}
      alt={task.status ? 'Mark Task Pending' : 'Mark Task Completed'}
      iconStyle={{
        '--fa-primary-color': 'white',
        '--fa-secondary-color': task.status ? '#2693D1' : 'lightgrey',
        '--fa-secondary-opacity': task.status ? 1.0 : 0.35,
      }}
      onClick={onClick}
    />
  </div>
);

export const FloatTopCPPIcon = ({ float, onClick, width = '20px', height = '20px', loading }) => (
  <Icon
    src="arrow-up-to-line"
    width={width}
    height={height}
    onClick={onClick}
    className={float ? 'blue' : ''}
    showTooltip={true}
    loading={loading}
    alt={float ? 'Unfloat from Top of CPP' : 'Float from Top of CPP'}
  />
);

export default CheckIcon;
